export enum PaidUnpaidFilter {
  paid = "1",
  unpaid = "0",
  all = "All",
}
